import {serverApiUrl} from "../index"

export const signUp=(logoPath,name,directorName,email,phone,password,address,city,state,category,about, status=0, callback)=>
{
    var formData   = new FormData();  
    formData.append("logoPath", logoPath) 
    formData.append("name", name) 
    formData.append("directorName", directorName) 
    formData.append("email", email) 
    formData.append("phone", phone) 
    formData.append("password", password) 
    formData.append("address", address) 
    formData.append("city", city) 
    formData.append("state", state) 
    formData.append("category", category) 
    formData.append("about", about) 
    formData.append("status",status)
    
    let headers = new Headers(); 

    fetch(serverApiUrl+'institute/',
    {
        method: 'POST',  
        body:formData
    })
    .then((response)=>callback(response)) 
    .catch((error)=>{console.log(error)})
} 


export const signUpPartial=async(name,directorName,email,phone,category)=>
{

    try{


        var formData   = new FormData();  
     
        formData.append("name", name) 
        formData.append("directorName", directorName) 
        formData.append("email", email) 
        formData.append("phone", phone) 
        formData.append("category", category) 
       
      
        const response  =  await fetch(serverApiUrl+'institute/createInstitutePartial',
        {
            method: 'POST',  
            body:formData
        })
        
        if(response.status==200||response.status==201)
        {
            const data = await response.json()
            return { status:true,data}
        }else{
                const data = await response.json()
                throw new Error(data.message)
        }
    }catch(e){
        return {
            status:false,
            message:e.message,
            
        }
    }
} 





export const verifySignUpOtp = async (otpValue,mobileNumber) => {
    // var formData   = new FormData(); 
    // formData.append("fetch_banners",'true') 
    // formData.append("offset",offset) 
    // formData.append("data_limit",limit)  
    let headers = new Headers(); 
    headers.append('Content-Type', 'application/json');
    // console.log(serverApiUrl+'institute/validate/',JSON.stringify({email,password}))
    try {
        const response = await fetch(serverApiUrl + '/otp/validate/',
            {
                method: 'POST',
                headers,
                body:JSON.stringify({otpValue,mobileNumber})
            })
            if(response.status==200)
            {
                const data=await response.json()
                return {status:true,data:data}
            }else{
                throw new Error("something went wrong "+response.status)
            }
        
    } catch (e) {
        return {status:false,error:e.message}
    }
}